import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getMainSlider(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getMainBanner",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainSections(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getMainSections",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainAdv(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getMainAdv",
      reset,
    );
  },
  // Где вызывается: не используется.
  async getModels(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getModels",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainProduction(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getMainProduction",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainNews(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getMainNews",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getNews(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getNews",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getProduction(Redis, pageSize = 1, pageNum = 20, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/baltex/getProduction?pageSize=${pageSize}&pageNum=${pageNum}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getNewsDetail(Redis, code, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/baltex/getNewsDetail?code=${code}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getProductionDetail(Redis, code, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/baltex/getProductionDetail?code=${code}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getAboutContent(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/baltex/getAboutContent`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMeta(Redis, page, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/baltex/getMeta?&page=${page}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainNumbers(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getMainNumbers",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getScripts(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getScripts",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getReviews(Redis, reset = false) {
    return await redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/baltex/getReviews",
      reset,
    );
  },
});
